import React from "react";
import { Alert, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../../enums/UrlPaths";
import authApi from "../../../utils/api/authApi";
import { snackbarSeverity } from "../../../hooks/useSnackbar";
import { zodResolver } from "@hookform/resolvers/zod";
import { passwordMatcher } from "../utils/zodPasswordMatcher";
import { EMPLOYEE_ACTIVATION } from "../../../enums/ApiPaths";
import { TEXT_FIELDS } from "../enums/EmployeeActivationFields";
import { getBearerToken, getTokenFromUrl, logout } from "../../../utils/Functions";
import { SnackbarContext } from "../../../contexts/Snackbar";
const ELSE_WIDTH = "40%";
export default function EmployeeActivationPage() {
  const { t } = useTranslation();
  const { register, formState: { errors }, handleSubmit, watch } = useForm({
    defaultValues: {
      Password: "",
      ConfirmPassword: "",
    },
    resolver: zodResolver(passwordMatcher(t)),
  });

  const navigate = useNavigate();
  const { handleSnackbar } = React.useContext(SnackbarContext);

  const submitData = async (e) => {
    const obj = watch();
    try {
      await authApi.post(EMPLOYEE_ACTIVATION + getTokenFromUrl(), obj);
      const token = await getBearerToken();
      if (token) {
        logout();
      }
      navigate(LOGIN);
    } catch (error) {
      handleSnackbar(error?.response?.data, snackbarSeverity.ERROR)
    }
  }

  return (
    <CenterScreen>
      <Stack
        sx={{
          width: {
            xs: "90%",
            sm: "90%",
            md: ELSE_WIDTH,
            lg: ELSE_WIDTH,
            xl: ELSE_WIDTH,
          },
        }}
        spacing={2}
      >
        <Alert variant="filled" severity="info">
          {t("AccountActivationInformation")}
        </Alert>
        <Paper sx={{ p: 3 }}>
          <Stack mb={2}>
            <Stack spacing={2}>
              <Typography variant="h4">{t("AccountActivation")}</Typography>
            </Stack>
          </Stack>
          <form onSubmit={handleSubmit(submitData)}>
            <Stack spacing={2} width={"100%"}>
              {TEXT_FIELDS.map((field) => (
                <TextField
                  key={field.name} 
                  label={t(field.label)}
                  variant={field.variant}
                  required
                  {...register(field.name)}
                  error={!!errors?.[field.name]}
                  helperText={errors?.[field.name]?.message || ""}
                  type={"password"}
                />
              ))}
              <Button type="submit" variant="contained" color="info">
                {t("ActivateAccount")}
              </Button>
            </Stack>
          </form>
        </Paper>
      </Stack>
    </CenterScreen>
  );
}
